/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminSingleDocumentData } from '@SERVICES';

export interface DocumentIntroductionTextModalState {
    isOpen: boolean;

    data: {
        documentData: AdminSingleDocumentData;
        canEditDocument: boolean;
    } | null;
}

export type DocumentIntroductionTextModalDispatchParams = {
    documentData: AdminSingleDocumentData;
    canEditDocument: boolean;
};

const initialState: DocumentIntroductionTextModalState = {
    isOpen: false,
    data: null,
};

export const documentIntroductionTextModalSlice = createSlice({
    name: 'document-introduction-text-modal',
    initialState,
    reducers: {
        open(state: DocumentIntroductionTextModalState, action: PayloadAction<DocumentIntroductionTextModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: DocumentIntroductionTextModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
}); 